import styled from '@emotion/styled';
import type { PlanColumn } from './buildBenefitTableData';
const TabContainer = styled.div`
  background-color: ${({
  theme
}) => theme.color.surface12Fixed};
  border: 1px solid ${({
  theme
}) => theme.color.surface3};
  box-sizing: border-box;
  padding: 2px;
  border-radius: 360px;
  display: flex;
  gap: 2px;
`;
const TabButton = styled.button<{
  $isActive: boolean;
  $isHighPlan: boolean;
}>`
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0px 6px;
  border-radius: 360px;
  border: none;
  cursor: pointer;

  font-weight: 700;
  font-size: 15px;
  line-height: 20px;

  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  color: ${({
  $isActive,
  $isHighPlan,
  theme
}) => {
  if (!$isActive) return theme.color.contentBrightFixed;
  return $isHighPlan ? theme.color.content12Fixed : theme.color.contentDeepFixed;
}};

  background-color: ${({
  $isActive,
  $isHighPlan,
  theme
}) => {
  if (!$isActive) return 'transparent';
  return $isHighPlan ? theme.color.primary1 : theme.color.surfaceBrightFixed;
}};

  :hover {
    background-color: ${({
  $isActive,
  theme
}) => {
  if (!$isActive) return theme.color.surface3;
}};
  }
`;
interface Props {
  planColumns: PlanColumn[];
  selectedPlanId?: string;
  onPlanSelect: (id: string) => void;
  className?: string;
}
const SubscriptionTabs = ({
  planColumns,
  selectedPlanId,
  onPlanSelect,
  className
}: Props) => {
  if (!planColumns.length) return null;
  return <TabContainer className={className} data-sentry-element="TabContainer" data-sentry-component="SubscriptionTabs" data-sentry-source-file="SubscriptionTabs.tsx">
      {planColumns.map(plan => <TabButton key={plan.id} $isActive={selectedPlanId === plan.id} $isHighPlan={plan.isHighPlan} onClick={() => onPlanSelect(plan.id)}>
          {plan.label}
        </TabButton>)}
    </TabContainer>;
};
export default SubscriptionTabs;